import React from 'react';
import Chart from 'react-apexcharts';

const OverAllStatus = ({ colorsNew, convertMinutes, tatStatusData, totalTat, showList = true }: any) => {

  const colors: any = {
    MelTat: "#5156be",
    TechnicianTat: "#FF9800",
    DealerTat: "#F44336",
    CustomerTat: "#9C27B0",
    SupplierTat: "#2196F3",
    CourierTat: "#4CAF50",
  };

  const Name: any = {
    MelTat: "Mel Tat",
    TechnicianTat: "Technician Tat",
    DealerTat: "Dealer Tat",
    CustomerTat: "Customer Tat",
    SupplierTat: "Supplier Tat",
    CourierTat: "Courier Tat",
  };

  // Extract series and labels
  const series = tatStatusData?.map((item: any) => item.tat) || [];
  const labels = tatStatusData?.map((item: any) => item.category) || [];

  // Map colors according to the category order
  const chartColors = labels.map((label: string) => colors[label] || '#ccc');

  const options: any = {
    chart: {
      type: 'donut',
    },
    labels: labels,
    legend: {
      position: 'bottom',
    },
    dataLabels: {
      enabled: true,
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${convertMinutes(((val ? val : 0) + 1) / 60)}`
      }
    },
    colors: chartColors,
    plotOptions: {
      pie: {
        donut: {
          size: '65%',
        },
      },
    },
  };


  return (
    <div className='w-100'>
      <p className='text-center mb-2 text-bold'>Overall TAT Status</p>

      <div className='d-flex flex-column align-items-center w-100'>
        <div style={{ width: "100%", maxWidth: '400px' }}>
          <Chart options={options} series={series} type="donut" width="100%" />
        </div>
        {showList && (
          <div style={{ width: "100%", marginTop: '20px' }}>
            <div className="tat-list">

              {tatStatusData
                ?.sort((a: any, b: any) => new Date(a.creationTime).getTime() - new Date(b.creationTime).getTime())
                ?.map((data: any, index: number) => {
                  return (
                    <React.Fragment key={index}>
                      <div className={`d-flex justify-content-between`}>
                        <div className="tat-name">
                          <div style={{ width: "10px", height: "10px", backgroundColor: data.color, borderRadius: "50%" }}></div>
                          <div style={{ fontWeight: "500" }}>{Name[data.category]}</div>
                        </div>
                        <div style={{ fontWeight: 400, color: "grey" }}>{convertMinutes(((data.tat ? data.tat : 0) + 1) / 60)}</div>
                      </div>
                      <hr />
                    </React.Fragment>
                  );
                })}
              <div className="d-flex justify-content-between mb-2">
                <div className="tat-name">
                  <div style={{ fontWeight: "500" }}>{'Total TAT'}</div>
                </div>
                <div style={{ fontWeight: 400, color: "grey" }}>{convertMinutes(((totalTat ? totalTat : 0) + 1) / 60)}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OverAllStatus;
